import { styled } from 'styled-components';
import { Button } from 'antd';

export const SiteName = styled.div`
  font-size: 18px;
`;

export const NavigationMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LogoutButton = styled(Button)`
  color: #ff4d4f;

  &:hover {
    color: #ff7875;
    background-color: #fff2f0;
  }
`;

export const HeaderBlock = styled.header`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #d9d9d9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;
